module.exports = __webpack_public_path__ + "img/lc-header-messages-active.8893af14.svg";